import { Button, Card, Stack, Text } from '@mantine/core';
import { useTranslationOrganization } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { redirectTo } from '@dealstack/frontend/shared/redirecting';

interface Props {
	domains: string[];
}

export const OrganizationDomain = ({ domains }: Props) => {
	const tOrganization = useTranslationOrganization();

	const subject = tOrganization('email.domain.subject');
	const body = tOrganization('email.domain.body');

	const title = tOrganization('domain.title');
	const subtitle = tOrganization('domain.subtitle');
	const buttonText = tOrganization('domain.button');

	const handleClick = () => {
		redirectTo(`mailto:support@dealstack.io?subject=${subject}&body=${body}`);
	};

	return (
		<Card
			bg="#FFF"
			radius={8}
			sx={{ border: '1px solid #E9EBED' }}
			data-testid="organization-auth-policy-card"
		>
			<Stack gap="md">
				<Text fz={14} fw={600} lh="20px" ff="Inter">
					{title}
				</Text>
				<Text c="#0E171C" fz={14} fw={400} lh="20px" ff="Inter">
					{subtitle}
				</Text>
				<Stack gap="xs">
					{domains.map((domain) => (
						<Card
							key={domain}
							p={8}
							radius={8}
							bg="#F4F5F6"
							data-testid={`organization-domain-card-${domain}`}
						>
							<Text
								fz={14}
								fw={600}
								c="#0E171C"
								lh="20px"
								ff="Inter"
								style={{
									fontVariantNumeric: 'lining-nums tabular-nums',
								}}
							>
								{domain}
							</Text>
						</Card>
					))}
				</Stack>
				<Button
					w="fit-content"
					data-testid="request-organization-domain-update"
					onClick={handleClick}
				>
					{buttonText}
				</Button>
			</Stack>
		</Card>
	);
};
